import React, { createContext, useContext, useState } from "react";

const CurrentPolicyContext = createContext();

export const useCurrentPolicyContext = () => useContext(CurrentPolicyContext);

export const CurrentPolicyProvider = ({ children }) => {
  const [currentSelectPolicyID, setCurrentSelectPolicyID] = useState(0);
  /* The number alongside the id, because the detail sheets have to name the
     policy even when the API returns nothing for it. A courier list comes back
     empty on most policies, and the rows are the only place the number appears
     — so with no rows there was nothing on screen saying which policy the
     customer was looking at. */
  const [currentSelectPolicyNo, setCurrentSelectPolicyNo] = useState("");

  return (
    <CurrentPolicyContext.Provider
      value={{
        currentSelectPolicyID,
        setCurrentSelectPolicyID,
        currentSelectPolicyNo,
        setCurrentSelectPolicyNo,
      }}
    >
      {children}
    </CurrentPolicyContext.Provider>
  );
};
